import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { Image } from 'components/Image/Image';
import './ScoreSimulatorBannerModule.scss';
import { isFree } from 'helpers/userHelper';
import { SUBSCRIPTION_VERTICAL } from 'types/mrph.vertical.constants';
import { POTENTIAL_SCORE_SIMULATOR } from 'types/morph.pagePosition.constants';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import {
  enrolledUrl,
  imageRight,
  scoreSimulatorUrl,
} from 'partial_OfferManager_modules_ScoreSimulatorBannerModule/ScoreSimulatorBannerModule.constants';

const ScoreSimulatorBannerModuleView = props => {
  const { userInfo, history, eventHandler, modulePosition, moduleHeading } =
    props;
  const freeUser = isFree(userInfo);

  const moduleName = POTENTIAL_SCORE_SIMULATOR + (freeUser ? ' Upsell' : '');

  const handleClick = () => {
    if (freeUser) {
      eventHandler(CLICK, {
        'Click Type': 'Score Simulation Banner CTA',
      });
      history?.push(enrolledUrl);
    } else {
      eventHandler(CLICK, {
        'Click Type': freeUser
          ? 'Score Simulation Banner CTA'
          : 'Plus - Score Simulation',
        'Module Name': moduleName,
        Vertical: SUBSCRIPTION_VERTICAL,
      });
      history?.push(scoreSimulatorUrl);
    }
  };

  const tracking = getViewModuleTrackingAttributes({
    moduleName,
    modulePosition,
    moduleHeading,
    vertical: SUBSCRIPTION_VERTICAL,
  });
  const seenPixel = useSeenModulePixel(tracking, undefined, true);

  return (
    <FlexContainer
      className="ScoreSimulatorBannerModule flex-column padLR28 m-padLR16 padT0 m-padT20 pointer margB20 m-margB10"
      onClick={handleClick}
    >
      {seenPixel}
      {freeUser && (
        <FlexContainer
          justifyBetween
          alignItemsCenter
          className="grayShadow borderRadius8 pad16"
        >
          <Label className="text-14 bold padLR8 lineHeight16">
            Upgrade to see how your actions can raise or lower your score.
          </Label>
          {imageRight}
        </FlexContainer>
      )}
      {!freeUser && (
        <FlexContainer
          justifyBetween
          alignItemsCenter
          className="grayShadow borderRadius8 pad8 system_neutral_n000"
        >
          <Image imgClass="magnifying" />
          <Label className="text-14 bold padLR8 lineHeight16">
            See how different actions can impact your score.
          </Label>
          <Image imgClass="chevron-right" />
        </FlexContainer>
      )}
    </FlexContainer>
  );
};

export default ScoreSimulatorBannerModuleView;
